import { Nature, Section, type LigneMouvement } from '@mairistem/comptabilite';
import type { ErrorField } from '@mairistem/liste';
import PROFIL_ECRITURE from '../../../../constants/mouvements/codeProfilEcritures';
import NATURE_PIECE from '../../../../constants/mouvements/naturePiece';
import NATURE_PIECE_ORIGINE from '../../../../constants/mouvements/naturePieceOrigine';
import { TYPE_BORDEREAU } from '../../../../constants/mouvements/typeBordereau';
import TYPE_PIECE from '../../../../constants/mouvements/typePiece';
import BaseProfilRattachement from '../Base/BaseProfilRattachement';
import CovidPanel from '../../panel/CovidPanel';
import PeriodeCouvertePanel from '../../panel/PeriodeCouvertePanel';
import ProjetPanel from '../../panel/ProjetPanel';
import CodeProduitLocalPanel from '../../panel/CodeProduitLocalPanel';
import CompteDeTiersPanel from '../../panel/CompteDeTiersPanel';
import RegiePanel from '../../panel/RegiePanel';
import MandatEmisApresPaiementPanel from '../../panel/InformationsRattachement/MandatEmisApresPaiementPanel';

class ProfilEcritureRegieEmiseApresEncaissement extends BaseProfilRattachement {
  constructor(anneeExercice: number) {
    super();
    this.code = PROFIL_ECRITURE.RECETTE.REGIE_EMISE_APRES_ENCAISSEMENT;
    this.typeBordereau = TYPE_BORDEREAU.RECETTE.ORDINAIRE;
    this.naturePiece = NATURE_PIECE.RECETTE.REGIE;
    this.typePiece = TYPE_PIECE.RECETTE.EMIS_APRES_PAIE;
    this.naturePieceOrigine = NATURE_PIECE_ORIGINE.TITRE.ENCAISSEMENT.CODE;
    this.exerRattachement = anneeExercice.toString();
    this.imputation.section = Section.FONCTIONNEMENT;
    this.imputation.nature = Nature.REEL;
    this.idLigneOriginePes = 0;
    this.panels = [
      new CodeProduitLocalPanel(true),
      new CompteDeTiersPanel(),
      new CovidPanel(),
      new MandatEmisApresPaiementPanel(true),
      new PeriodeCouvertePanel(),
      new ProjetPanel(),
      new RegiePanel(true),
    ];
  }

  checkLigne(ligne: LigneMouvement): ErrorField[] {
    const errors: ErrorField[] = [];

    errors.push(...super.checkLigne(ligne));

    if (parseInt(ligne.exerRattachement, 10) > parseInt(this.exerRattachement, 10)) {
      errors.push({
        id: 'mouvement-exerRattachement',
        message: "L'exercice de rattachement doit correspondre à un exercice antérieur ou égal à celui du mouvement",
      });
    }

    if (ligne.idLigneOriginePes !== 0) {
      errors.push({
        id: `ligneMouvement-idLigneOriginePes-${ligne?.identifiant}`,
        message: "L'identifiant de la ligne d'origine PES doit être égal à 0",
      });
    }

    return errors;
  }
}

export default ProfilEcritureRegieEmiseApresEncaissement;
